<template>
  <el-tabs v-model="activeName">
    <el-tab-pane
      v-for="item in tabOtion"
      :key="item.name"
      :label="item.label"
      :name="item.name"
    >
      <component :is="item.component" />
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import individualBusiness from './components/individualBusiness.vue';
import organizationalChart from './components/organizationalChart.vue';

const tabOtion = [
  {
    label: '组织机构',
    name: 'organizationalChart',
    component: organizationalChart,
  },
  {
    label: '个体工商户',
    name: 'individualBusiness',
    component: individualBusiness,
  },
];
export default {
  name: 'PrincipalManage',
  data() {
    return {
      activeName: 'organizationalChart',
      tabOtion,
    };
  },
  methods: {

  },
};
</script>

<style lang="scss" scoped>

</style>
